// ----------------------------------------------------------------------

const account = {
  displayName: 'Jaydon Frankie',
  email: 'hello@weholo.studio',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
